import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../molecules/Table/Table';
import { PackageCompatibilityTableProps } from './PackageCompatibilityTable.types';

export const PackageCompatibilityTable = ({
  unityVersion,
  renderPipelines,
  buildTarget,
  microcopy,
  className,
}: PackageCompatibilityTableProps) => {
  return (
    <Table className={className}>
      <TableCaption>{microcopy.title}</TableCaption>

      <TableHeader className="sr-only">
        <TableRow>
          <TableHead>{microcopy.headerColumn1}</TableHead>
          <TableHead>{microcopy.headerColumn2}</TableHead>
        </TableRow>
      </TableHeader>

      <TableBody variant="alternate">
        <TableRow>
          <TableHead scope="row" className="!align-top">
            {microcopy.unityVersion}
          </TableHead>
          <TableCell className="w-44 break-normal">
            {unityVersion.join(', ')}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableHead scope="row" className="!align-top">
            {microcopy.renderPipelines}
          </TableHead>
          <TableCell>{renderPipelines.join(', ')}</TableCell>
        </TableRow>
        <TableRow>
          <TableHead scope="row" className="!align-top">
            {microcopy.buildTarget}
          </TableHead>
          <TableCell>{buildTarget.join(', ')}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
